import React from 'react';
import './CrewTimesheet.scss';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import TimesheetDetailTimeModal from './TimsheetDetailTimeModal';
import cls from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faUserSlash } from '@fortawesome/free-solid-svg-icons';
import { getTreatAsRemoved } from './TimesheetDetail';
import { fromUtcToLocalMoment } from '../utilities/DateHelpers';

export default class TimesheetDetailTimeButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { showModal: false };

        this.toggleModal = this.toggleModal.bind(this);
    }

    isTimeBoundSet = (timesheet, isAdmin) =>
        Boolean(
            timesheet &&
            ((timesheet.startTime && timesheet.endTime) ||
                (isAdmin &&
                    timesheet.adjustedStartTime &&
                    timesheet.adjustedEndTime))
        );

    toggleModal() {
        const { showModal } = this.state;
        const { timesheet, isAdmin } = this.props;

        if (!this.isTimeBoundSet(timesheet, isAdmin)) {
            this.setState({ showModal: false });
            return;
        }

        this.setState({ showModal: !showModal });
    }

    getComponentDescription() {
        const { employee, equipment } = this.props;

        if (employee && employee.id) {
            return `${employee.lastName}, ${employee.firstName} (#${employee.employeeNumber})`;
        }

        return `${equipment.description} (#${equipment.identifier})`;
    }

    getStartTime() {
        const { timesheetDetail } = this.props;

        return fromUtcToLocalMoment(
            timesheetDetail.adjustedStart ?? timesheetDetail.start
        );
    }

    getEndTime() {
        const { timesheetDetail } = this.props;

        return (timesheetDetail.adjustedEnd ?? timesheetDetail.end)
            ? fromUtcToLocalMoment(
                  timesheetDetail.adjustedEnd ?? timesheetDetail.end
              )
            : null;
    }

    getIsComplete() {
        const { timesheetDetail, isAdmin } = this.props;

        const startTime = this.getStartTime();
        const endTime = this.getEndTime();

        return Boolean(
            (((timesheetDetail.start && timesheetDetail.end) ||
                (timesheetDetail.adjustedStart &&
                    timesheetDetail.adjustedEnd)) &&
                endTime > startTime) ||
            (isAdmin && timesheetDetail.adjustedRemoved) ||
            (!isAdmin && timesheetDetail.removed)
        );
    }

    getHasBeenAdjusted() {
        const { timesheetDetail } = this.props;

        return Boolean(
            timesheetDetail.adjustedStart ||
            timesheetDetail.adjustedEnd ||
            timesheetDetail.adjustedRemoved === false ||
            timesheetDetail.adjustedRemoved === true
        );
    }

    render() {
        const {
            loading,
            employee,
            equipment,
            timesheetDetail,
            isAdmin,
            timesheet,
            isReadOnly,
            absenceReasons,
        } = this.props;

        const { showModal } = this.state;

        if (loading || (!employee && !equipment) || !timesheetDetail) {
            return null;
        }

        const startTime = this.getStartTime();

        const startTimeDisplay = startTime.format('hh:mm A');

        const endTime = this.getEndTime();

        const endTimeDisplay = endTime ? endTime.format('hh:mm A') : 'Not Set';

        const componentDescription = this.getComponentDescription();

        const hasBeenAdjusted = this.getHasBeenAdjusted();

        const complete = this.getIsComplete();

        const treatAsRemoved = getTreatAsRemoved(timesheetDetail);

        const leadIn = isReadOnly ? 'Start/' : 'Update start/';
        const headerText = `${leadIn}end time - ${componentDescription}`;

        const absenceReasonId =
            timesheetDetail.adjustedAbsenceReasonId ??
            timesheetDetail.absenceReasonId;

        const absenceReason = absenceReasons.find(
            (ar) => ar.id == absenceReasonId
        );

        return (
            <>
                <Card
                    onClick={this.toggleModal}
                    className="timesheet-detail-time-card"
                >
                    <CardHeader className={cls({ complete })}>
                        {componentDescription}

                        {hasBeenAdjusted && (
                            <FontAwesomeIcon icon={faEdit} className="ml-2" />
                        )}
                    </CardHeader>
                    {!treatAsRemoved && (
                        <CardBody
                            className={cls({
                                'text-danger': !this.isTimeBoundSet(
                                    timesheet,
                                    isAdmin
                                ),
                            })}
                        >
                            {startTimeDisplay} - {endTimeDisplay}
                        </CardBody>
                    )}

                    {treatAsRemoved && (
                        <CardBody>
                            <FontAwesomeIcon
                                icon={faUserSlash}
                                className="mr-1"
                            />
                            {absenceReason.name}
                        </CardBody>
                    )}

                    {(timesheetDetail.adjustmentNotes ||
                        timesheetDetail.notes) && (
                        <CardFooter>
                            <div>
                                Notes:{' '}
                                {timesheetDetail.adjustmentNotes ??
                                    timesheetDetail.notes}
                            </div>
                        </CardFooter>
                    )}
                </Card>

                <TimesheetDetailTimeModal
                    toggleModal={this.toggleModal}
                    timesheetDetail={timesheetDetail}
                    showModal={showModal}
                    headerText={headerText}
                    {...this.props}
                />
            </>
        );
    }
}
